import React, { useState } from 'react';
import * as Common from "../CommonControlls/CommonJs";
import MainLayout from "../CommonControlls/MainLayout";
import Topmenu from "../CommonControlls/Topmenubar";
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
const HelpDesk_Add = () => {
    const [imageData, setImageData] = useState(null);
    const [youtubeVideoUrl, setYoutubeVideoUrl] = useState('');
    const [title, setTitle] = useState('');
    const [validationError, setValidationError] = useState({ title: false,  file: false });
    const [images, setImages] = useState([]);
    const history = useHistory();
    const handleFileChange = (event) => {
        const image = event.target.files[0];
        setImageData(image);
    };

    const handleUrlChange = (event) => {
        setYoutubeVideoUrl(event.target.value);
    };

    const handleTitleChange = (event) => {
        setTitle(event.target.value);
    };

    const clearForm = () => {
        setImageData(null);
        setYoutubeVideoUrl('');
        setTitle('');
        setValidationError({ title: false, url: false, file: false });
    };

    const handleUpload = () => {
        if (!title || !imageData) {
            // Validation failed
            setValidationError({
                title: !title,
                
                file: !imageData
            });
            return;
        }

        const imageUploadModel = new FormData();
        imageUploadModel.append('ImageFile', imageData);
        imageUploadModel.append('YoutubeVideoUrl', youtubeVideoUrl || null);
        imageUploadModel.append('Title', title);

        fetch(Common.APILinks.HelpDesk_Create, {
            method: 'POST',
            body: imageUploadModel,
            headers: {
                // Omitting 'Content-Type' header, as FormData sets it automatically
            },
        })
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error('Failed to upload image');
                }
            })
            .then(data => {
                alert('Request Post successfully');
                history.push('/HelpDesk');
                setImages(data || []);
                clearForm();
            })
            .catch(error => {
                console.error('Error uploading image:', error);
            });

    };

    return (
        <div>
            <MainLayout />
            <div id="right-panel" className="right-panel">
                <Topmenu
                    PageTitle="Help Module"
                    isShowAddBtn={true}
                    AddBtnLabel="Back to list"
                    AddBtnLink="/HelpDesk"
                />
                <div class="content">
                    <div class="PageHeader_Container">
                        <h2>Post Help</h2>
                    </div>

                    <div class="card col-md-8 col-lg-8">
                        <div class="card-body row">
                            <Container>
                                <Row>
                                    <Col>
                                        <Form>
                                            <div class="row">
                                                <div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                    <label for=""><span style={{ color: "red" }}>* </span>Title</label>
                                                    <input
                                                        autoComplete="off"
                                                        type="text"
                                                        class={`form-control ${validationError.title ? 'is-invalid' : ''}`}
                                                        id="Title"
                                                        placeholder="Enter Title"
                                                        value={title}
                                                        onChange={handleTitleChange}
                                                    />
                                                    {validationError.title && <div className="invalid-feedback">Title is required</div>}
                                                </div>

                                                <div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                    <label for=""><span style={{ color: "red" }}>*</span>Url</label>
                                                    <input
                                                        class={`form-control ${validationError.url ? 'is-invalid' : ''}`}
                                                        type="text"
                                                        placeholder='Enter Youtube Url'
                                                        value={youtubeVideoUrl}
                                                        onChange={handleUrlChange}
                                                    />
                                                    {validationError.url && <div className="invalid-feedback">Youtube URL is required</div>}
                                                </div>

                                                <div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                    <label for=""><span style={{ color: "red" }}>*</span>Attachment</label>
                                                    <input
                                                        type="file"
                                                        onChange={handleFileChange}
                                                        class={`form-control-file ${validationError.file ? 'is-invalid' : ''}`}
                                                    />
                                                    {validationError.file && <div className="invalid-feedback">File is required</div>}
                                                </div>
                                                <div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                    <Button variant="primary" style={{ marginTop: '35px' }} onClick={handleUpload}>
                                                        Save
                                                    </Button></div>

                                            </div>
                                        </Form>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HelpDesk_Add;
